/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withTranslation } from 'react-i18next';

import Alert from '../../Common/AlertContainer';
import Error from '../../Common/Error';
import { formValidator, removeSpecialCharacters } from '../../../AppUtil/AppUtil';
import { commonStyle } from '../../Common/CommonStyle';
import CountryCodeField from '../../Common/CountryCodeField';
import MaskedInputField from '../../Common/MaskedInputField';

const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_countryCode: '+63',
			_error_message: '',
			_forgotPasswordForm: {
				phone: {
					value: '',
					placeholder: 'label.contact',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_contact'
						},
						pattern: {
							value: PATTERN.CONTACT,
							errorMsg: 'error_message.invalid_contact'
						}
					},
					error_text: ''
				}
			}
		};
	}

	/**
	 * This function handle all input change event inside login form
	 * @returns {void}
	 */
	handelInputChange = e => {
		this.props.resetAuthError();
		const name = e.target.name;
		let value = e.target.value;
		const forgotPasswordForm = {
			...this.state._forgotPasswordForm
		};
		const updatedFormElement = {
			...forgotPasswordForm[name]
		};
		if (name === 'phone') {
			value = removeSpecialCharacters(value);
		}
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		forgotPasswordForm[name] = updatedFormElement;
		this.setState({
			_forgotPasswordForm: forgotPasswordForm
		});
	};

	/**
	 * This function handle submit login form
	 * @returns {Promise<void>}
	 */
	onSubmitHandler = async e => {
		e.preventDefault();
		this.props.resetAuthError();
		if (!this.formValidator()) {
			return false;
		}
		const error_message = 'No DATA found in Database';
		const phone = this.state._countryCode + this.state._forgotPasswordForm.phone.value;

	
		if ((await this.props.verifyPhoneIfExist(phone)) === error_message) {
			this.setState({ _error_message: 'Phone number does not exist' });
		} else {
			await this.props.onForgot(phone);
		}
	};

	/**
	 * This function validate all field in login form
	 */
	formValidator = () => {
		const form = {
			...this.state._forgotPasswordForm
		};

		const [updatedForm, isFormValid] = formValidator(form);
		this.setState({
			_forgotPasswordForm: updatedForm
		});
		return isFormValid;
	};
	setCountryCode = e => {
		this.setState({
			_countryCode: e.target.value
		});
	};
	render() {
		const { classes } = this.props;
		const { t } = this.props;
		return (
			<Container component="main" maxWidth="md">
				<CssBaseline />
				<Paper className={classes.paper} id="paperform">
					<Grid
						// id='full-wdith'
						item
						md
						zeroMinWidth>
						<div>
							<div className={classes.paper} id="paperform">
								<Avatar className={classes.avatar}>
									<LockOutlinedIcon />
								</Avatar>
								<Typography component="h1" variant="h5">
									{t('label.forgot_password')}
								</Typography>
								<Typography className="text-center light-gray">
									{t('signin.forgot_password_heading')}
								</Typography>
								<form
									className={classes.form}
									noValidate
									onSubmit={this.onSubmitHandler}
									style={{ maxWidth: '420px' }}>
									<Grid container justify="center" spacing={1}>
										<Grid item sm={2} xs={3}>
											<CountryCodeField
												setCountryCode={this.setCountryCode}
												value={this.state._countryCode}
											/>
										</Grid>
										<Grid item sm={10} style={{ marginTop: '16px' }} xs={9}>
											<MaskedInputField
												error={
													!this.state._forgotPasswordForm.phone.isValid &&
													this.state._forgotPasswordForm.phone.isTouched
												}
												error_text={t(this.state._forgotPasswordForm.phone.error_text)}
												handleChange={this.handelInputChange}
												autoFocus={true}
												required
												label={t(this.state._forgotPasswordForm.phone.placeholder)}
												value={this.state._forgotPasswordForm.phone.value}
											/>
										</Grid>
									</Grid>
									<Error text={t(this.props.authError) || this.state._error_message} />
									<div className={classes.blockdiv}>
										<Fab
											aria-label="add"
											className={classes.submit}
											color="primary"
											onClick={this.onSubmitHandler}
											size="medium"
											type="submit"
											variant="extended">
											{t('buttons.submit')} &nbsp;
											{this.props.isLoading ? (
												<CircularProgress disableShrink size={18} />
											) : (
												<ArrowForwardIcon />
											)}
										</Fab>
									</div>
									<Grid container justify="center">
										<Link
											href="#"
											onClick={e => {
												e.preventDefault();
												this.props.openSignInForm();
											}}
											variant="body2">
											{t('signin.sign_in')}
										</Link>
									</Grid>
								</form>
							</div>
						</div>
					</Grid>
				</Paper>
				<Alert
					message={this.props.alert._message || ''}
					onClose={this.props.hideAlert}
					severity={this.props.alert._severity || 'success'}
					show={this.props.alert._show || false}
				/>
			</Container>
		);
	}
}

export default withStyles(commonStyle)(withTranslation()(index));
